import { HeroBackgroundImage } from "../../../../modules/content/components/HeroBackgroundImage/HeroBackgroundImage";
import { HeroSplitImage } from "../../../../modules/content/components/HeroSplitImage/HeroSplitImage";
import { GroundSection } from "../../../../modules/content/components/GroundSection/GroundSection";
import type { IHeroBlockProps } from "./HeroBlock.props";

export const HeroBlock = (props: IHeroBlockProps) => {
  if (!props.image) return null;
  return (
    <GroundSection
      className={props.parentClass}
      containerWidth="wide"
      id={props.anchorId}
      spacing={props.spacing}
    >
      {props.variant === "split-image" ? (
        <HeroSplitImage {...props} />
      ) : (
        <HeroBackgroundImage {...props} />
      )}
    </GroundSection>
  );
};

HeroBlock.displayName = "Block::HeroBlock";
